import { HttpResponseBase } from '@angular/common/http';

const CODE_MESSAGE = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
};

export const keyMap = {
  go: {
    pub: '047ce6371cc9c4f224eb07a6738055bb4dfd5a2e146d905508570c94db8dd2a930948ef59ec43b6130e789e1133d7c732ecedc762dca0deee40fef5a39c64c2249',
    pri: '676a073adb4697d22b8c4596334adb15db01de9f5adbd04352a3a1c84a7e396e'
  },
  x: {
    pub: '04674b07b4e03a5e2acd525ec34b52471a2293c00483b69fb3c17bf347e4572413801ab719759b38b6916076271640146efa3ee14bc41d2985a2d4755aa8b7b79f',
    pri: '79fef609bbc15e2add9afe2834db8bb60db4592dd4fbb768482d6bae6db49727'
  },
  icbc: {
    pub: '04ec4d55a965923d7dee0c1708b24131acdc3fadfb65ac276297c1528dcebb146c5a9da74051d302bc3a51ed2f8eaf005dc19c357313729f5c12bcf7effd057b96',
    pri: 'eb5d3b1a2221fe47342538ed767cdabe6b17e9d28e51928b709d122257d2d718'
  },
  other: {
    pub: '04e5866fc82bd57953f38c6cdab9c63af307fb13a233e8ff3e40815b6e6d29efdb53a9afd3d15bb56e6485f802bfc801cdfda906abafd4102f3a661d7c20ea05f9',
    pri: '1ba88920465a3cd52c5731e5d5e4be7b32a6119687d90fc57ed830cbc136e9bb'
  }
};

export function checkStatus(ev: HttpResponseBase) {
  if (ev.url.includes('common/getFrontendSystemConfig')) return;
  if ((ev.status >= 200 && ev.status < 300) || ev.status === 401 || ev.status === 0) return;

  const errorText = CODE_MESSAGE[ev.status] ?? ev.statusText;
  window.alert(`请求错误 ${ev.status}: ${ev.url} ${errorText}`);
}
